import { useEffect, useState, useContext } from '@wordpress/element';
import { useCartData, useRetailerData } from './dutchie-queries';
import { ConfigContext } from '../index.js';

export default function usePricingType(retailerId) {
    const medPricingTypes = {
        standard: 'priceMed',
        special: 'specialPriceMed',
    };

    const recPricingTypes = {
        standard: 'priceRec',
        special: 'specialPriceRec',
    };

    const [pricingTypes, setPricingTypes] = useState(recPricingTypes);
    
    const { data: cartData, isFetched: isFetchedCartData } = useCartData(retailerId);
    const { data: retailerData, isFetched: isFetchedRetailerData } = useRetailerData(retailerId);
    
    const config = useContext(ConfigContext);
    const retailers = config?.retailers || {};
    const nonHeadlessRetailers = config?.nonHeadlessRetailers || [];

    const getCurrentRetailer = () => {
        if (!retailerId || !retailers || !nonHeadlessRetailers) return null;
        
        const currentNonHeadlessRetailer = nonHeadlessRetailers.find(r => r.id === retailerId);
        if (currentNonHeadlessRetailer) {
            return currentNonHeadlessRetailer;
        }
        return retailers[retailerId] || null;
    };

    useEffect(() => {
        if (isFetchedCartData && isFetchedRetailerData) {
            const currentRetailer = getCurrentRetailer();
            
            if (currentRetailer && currentRetailer.menuType === 'medical') {
                setPricingTypes(medPricingTypes);
            } else if (cartData?.pricingType === 'RECREATIONAL') {
                setPricingTypes(recPricingTypes);
            } else {
                setPricingTypes(medPricingTypes);
            }
        }
    }, [cartData, isFetchedCartData, retailerData, isFetchedRetailerData, retailerId, retailers, nonHeadlessRetailers]);

    return [pricingTypes];
}
